/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions
     */
    XsollaEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions
     */
    YookassaEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions
     */
    StripeEnabled: boolean;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions {
    if (!('XsollaEnabled' in value) || value['XsollaEnabled'] === undefined) return false;
    if (!('YookassaEnabled' in value) || value['YookassaEnabled'] === undefined) return false;
    if (!('StripeEnabled' in value) || value['StripeEnabled'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'XsollaEnabled': json['XsollaEnabled'],
        'YookassaEnabled': json['YookassaEnabled'],
        'StripeEnabled': json['StripeEnabled'],
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseStoreOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'XsollaEnabled': value['XsollaEnabled'],
        'YookassaEnabled': value['YookassaEnabled'],
        'StripeEnabled': value['StripeEnabled'],
    };
}

